"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-4b2bbaa1-ae1e-4f68-802b-544777832c64",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486.86 171.09",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M436.32,21.86c0-12.06-9.81-21.86-21.87-21.86H21.86C9.81,0,0,9.81,0,21.86v127.36c0,12.06,9.81,21.87,21.86,21.87H414.45c12.06,0,21.87-9.81,21.87-21.87v-16.18h-14v16.18c0,4.34-3.53,7.87-7.87,7.87H21.86c-4.34,0-7.86-3.53-7.86-7.87V21.86c0-4.34,3.53-7.86,7.86-7.86H414.45c4.34,0,7.87,3.53,7.87,7.86v16.17h14V21.86Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "128.57 48.57 70.41 48.57 48.32 85.55 70.39 122.5 83.63 122.5 128.57 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "356.49 48.57 311.56 122.5 337.75 122.5 382.68 48.57 356.49 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "153.14 48.57 108.21 122.5 134.4 122.5 179.33 48.57 153.14 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "305.58 48.57 260.65 122.5 286.99 122.5 331.92 48.57 305.58 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "407.26 48.57 362.33 122.5 388.69 122.5 433.62 48.57 407.26 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "254.84 48.57 209.91 122.5 236.07 122.5 281 48.57 254.84 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "203.9 48.57 158.97 122.5 185.34 122.5 230.27 48.57 203.9 48.57",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "486.86 84.88 464 122.5 486.86 122.5 486.86 84.88",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("polygon", {
      points: "413.26 122.5 439.43 122.5 484.36 48.57 458.2 48.57 413.26 122.5",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;